import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import submit from './submit';
import validate from './validate';

// Style
import cx from 'classnames';
import {
  Button,
  Row,
  FormGroup,
  Col,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './FindYourVehicleForm.css';
import cs from '../../../components/commonStyle.css';
import Uploader from './Uploader/Uploader';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import { url } from '../../../config';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import MultiLanguageInput from '../MultiLanguageInput/MultiLanguageInput';

class FindYourVehicleForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      addMore: [],
      addMoreCount: 1
    };
    this.handleAddMore = this.handleAddMore.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleFieldChange(fieldName, value) {
    const { dispatch } = this.props;
    dispatch(change('FindYourVehicleForm', fieldName, value));
  }

  componentDidMount() {
    const { initialValues } = this.props;

    let list = [], num = 0
    const values = Object.keys(initialValues).map((item) => {
      if (item.startsWith('content') && initialValues[item] != '') {
        num = num + 1
        return list.push(`${num}`)
      }
    })
    if (list.length < 1) {
      this.setState({
        addMore: ["1"],
        addMoreCount: 1
      });
    } else {
      this.setState({
        addMore: list,
        addMoreCount: num
      });
    }

  }

  handleAddMore() {
    const { addMore, addMoreCount } = this.state;
    let count = addMoreCount + 1;
    let addMoreUpdate = addMore.concat(`${count}`);
    if (count < 6) {
      this.setState({
        addMore: addMoreUpdate,
        addMoreCount: count
      });
    }
  }

  async handleRemove() {
    const { change } = this.props;
    const { addMore, addMoreCount } = this.state;
    let addMoreUpdate = addMore.filter((item) => item != addMoreCount);
    let count = addMoreCount - 1;
    if (count >= 3) {
      this.setState({
        addMore: addMoreUpdate,
        addMoreCount: count
      });
      await change(`content${addMoreCount}`, null);
    }
  }


  render() {

    const { error, handleSubmit, submitting, dispatch, initialValues, title, formValues } = this.props;
    const { formatMessage } = this.props.intl;
    const { addMore, addMoreCount } = this.state;
    // Hidden fields to register multilingual fields with Redux Form
    const multilingualFields = ['heading', 'buttonLabel', 'content1', 'content2', 'content3', 'content4', 'content5'];
    const langSuffixes = ['_en', '_fr', '_it', '_pt'];
    const hiddenFields = [];
    multilingualFields.forEach(base => {
      langSuffixes.forEach(suffix => {
        hiddenFields.push(
          <Field key={`${base}${suffix}`} name={`${base}${suffix}`} component="input" type="hidden" />
        );
      });
    });

    return (
      <div className={cx(s.pagecontentWrapper, 'linkAddon')}>
        <div>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <h1 className={s.headerTitle}><FormattedMessage {...messages.findYourCarInfo} /></h1>
              
              <form onSubmit={handleSubmit((values) => {
                // Merge redux-form values with formValues to ensure all multilingual fields are sent
                const payload = { ...values, ...formValues };
                console.log('🚀 [FindYourVehicleForm] Sending:', payload);
                return submit(payload, dispatch);
              })}>
                {/* Toggle to enable/disable this block on homepage */}
                <div className={s.toggleContainer}>
                  <label className={s.toggleLabel}>
                    <FormattedMessage {...messages.showOnHomepage} />
                  </label>
                  <label className={s.toggleSwitch}>
                    <Field
                      name="isEnabled"
                      component="input"
                      type="checkbox"
                      className={s.toggleInput}
                    />
                    <span className={s.toggleSlider}></span>
                  </label>
                  <span className={s.toggleStatus}>
                    {formValues?.isEnabled ? 'Activo' : 'Inactivo'}
                  </span>
                </div>

                {/* Hidden fields to register multilingual fields */}
                {hiddenFields}
                {error && <strong>{formatMessage(error)}</strong>}
                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <div className={cx(s.siteContainer)}>
                      <label className={cs.labelTextNew} ><FormattedMessage {...messages.imageLabel} /></label>
                      <Uploader />
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12} className={s.mobileTop}>
                    <label className={cx(cs.labelTextNew)}><FormattedMessage {...messages.headingLabel} /></label>
                    <MultiLanguageInput
                      baseField="heading"
                      inputType="text"
                      values={formValues}
                      onChange={this.handleFieldChange}
                    />
                    <label className={cx(cs.labelTextNew, cs.spaceTop3)} ><FormattedMessage {...messages.buttonLabel} /></label>
                    <MultiLanguageInput
                      baseField="buttonLabel"
                      inputType="text"
                      values={formValues}
                      onChange={this.handleFieldChange}
                    />
                    <label className={cx(cs.labelTextNew, cs.spaceTop3)} ><FormattedMessage {...messages.buttonLink} /></label>
                    <Field
                      name="buttonLink"
                      component={CommonFormComponent}
                      isAddon={true}
                      suffixLabel={url}
                      inputClass={cx(cs.formControlInput, s.addonInputRadius)}
                      label={formatMessage(messages.buttonLink)}
                    />
                      <label className={cx(cs.labelTextNew, cs.spaceTop3)} ><FormattedMessage {...messages.contentLabel} /> #1</label>
                    <MultiLanguageInput
                      baseField="content1"
                      inputType="textarea"
                      values={formValues}
                      onChange={this.handleFieldChange}
                    />
                    <label className={cx(cs.labelTextNew, cs.spaceTop3)} ><FormattedMessage {...messages.contentLabel} /> #2</label>
                    <MultiLanguageInput
                      baseField="content2"
                      inputType="textarea"
                      values={formValues}
                      onChange={this.handleFieldChange}
                    />
                    <label className={cx(cs.labelTextNew, cs.spaceTop3)} ><FormattedMessage {...messages.contentLabel} /> #3</label>

                    <MultiLanguageInput
                      baseField="content3"
                      inputType="textarea"
                      values={formValues}
                      onChange={this.handleFieldChange}
                    />

                    {
                      addMore.includes('4') && <>

                        <label className={cx(cs.labelTextNew, cs.spaceTop3)} ><FormattedMessage {...messages.contentLabel} />#4</label>

                        <MultiLanguageInput
                          baseField="content4"
                          inputType="textarea"
                          values={formValues}
                          onChange={this.handleFieldChange}
                        />
                      </>}

                    {
                      addMore.includes('5') && <>
                        <label className={cx(cs.labelTextNew, cs.spaceTop3)} ><FormattedMessage {...messages.contentLabel} />#5</label>
                        <MultiLanguageInput
                          baseField="content5"
                          inputType="textarea"
                          values={formValues}
                          onChange={this.handleFieldChange}
                        />
                      </>}

                    <div className={cs.dFlexWrapAlignEnd}>
                    {addMoreCount > 3 && <Button className={cx(cs.btnPrimaryBorder, cs.btnLarge, cs.nofocus, cs.spaceTop3, s.addLink, s.removeColor)} type="button" disabled={submitting} onClick={() => this.handleRemove()}>
                        <FormattedMessage {...messages.remove} />
                      </Button>}
                      {addMoreCount < 5 && <Button className={cx(cs.btnPrimary, cs.btnLarge, cs.spaceTop3, s.addLink)} type="button" disabled={submitting} onClick={() => this.handleAddMore()}>
                        <FormattedMessage {...messages.addLabel} />
                      </Button>}
                     
                    </div>
                  </Col>
                </Row>

                <FormGroup className={s.noMargin}>
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12} className={cx(cs.textAlignRight, 'textAlignLeftRTL', cs.spaceTop3)}>
                      <Button className={cx(cs.btnPrimary, cs.btnlarge)} type="submit" disabled={submitting}>
                        <FormattedMessage {...messages.save} />
                      </Button>
                    </Col>
                  </Row>
                </FormGroup>
              </form>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

}

FindYourVehicleForm = reduxForm({
  form: 'FindYourVehicleForm', // a unique name for this form
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(FindYourVehicleForm);

const selector = formValueSelector('FindYourVehicleForm');

// Build formValues mapping for all multilingual fields
const textFields = ['heading', 'buttonLabel', 'content1', 'content2', 'content3', 'content4', 'content5'];
const languages = ['', '_en', '_fr', '_it', '_pt'];

const mapState = (state) => {
  const formValues = {};
  textFields.forEach(field => {
    languages.forEach(lang => {
      formValues[`${field}${lang}`] = selector(state, `${field}${lang}`);
    });
  });
  formValues.isEnabled = selector(state, 'isEnabled');
  return { formValues };
};

export default injectIntl(withStyles(s, cs)(connect(mapState)(FindYourVehicleForm)));